import { t } from "i18next";
import "./styles/Login.css"
import { GRAPH_RIGHTS_SOCPE } from "../Constant";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import packageJson from '../../package.json';
import { TeamsFxContext } from "../components/Context";
import Loader from "../components/Loader";

const Login = () => {

    const [hasInited, setHasInited] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();
    const { teamsUserCredential } = useContext(TeamsFxContext);

    useEffect(() => {
        checkIsAuth();
    }, []);

    const checkIsAuth = async () => {
        try {
            if (teamsUserCredential) {
                // On utilise getToken pour tester car il tente de se connecter de manière silencieuse contrairement à login qui affiche une popup à l'utilisateur
                await teamsUserCredential?.getToken(GRAPH_RIGHTS_SOCPE);
                navigate("/home");
            }
        } catch(e:any) {
            console.log("l'identifiaction silentieuse n'a pas marché", e);
            // On ne fait rien dans la catch car cela veur dire que l'utilisateur n'a pas autorisé l'appli
            // on attends qu'il le fasse pour le rediriger vers la Home
            setHasInited(true);
            setIsLoading(false);
        }
    }

    const login = async () => {
        try {
            if(teamsUserCredential) {
                await teamsUserCredential.login(GRAPH_RIGHTS_SOCPE);
                setIsLoading(true);
                await tryNavigateHome();
            }
        }
        catch(e: any) {
            console.log("User did not logged", e);
        }
    }

    /**
     * Fonction qui boucle tant que teamsUserCredential?.getToken renvoie une errteur et qui navige vers la home une fois qu'il passe.
     */
    const tryNavigateHome = async () => {
        try {
            await teamsUserCredential?.getToken(GRAPH_RIGHTS_SOCPE);
            navigate("/home");
        } catch (e) {
            console.log("tryNavigateHome, erreur, ", e);
            await tryNavigateHome();
        }
    }

    return (
        <div className="login-container">
            <Loader visible={isLoading}/>
            {
                (hasInited && !isLoading) &&
                <div className="login-modal">
                    <p className="login-text">{t("login_msg")}</p>
                    <button className="login-button" onClick={login}>{t("login_button")}</button>
                </div>
            }
            <span className="version">{packageJson.version}</span>
        </div>


    )
}

export default Login;

